import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataEntity_Detail_05_Interface } from 'src/app/Interface/DataEntity/05/DataEntity_Detail_05_Interface';
import { DataEntity_Main_05_Interface } from 'src/app/Interface/DataEntity/05/DataEntity_Main_05_Interface';
import { DataEntity_Resolution_05_Interface } from 'src/app/Interface/DataEntity/05/DataEntity_Resolution_05_Interface';
import { DataEntity_Working_05_Interface } from 'src/app/Interface/DataEntity/05/DataEntity_Working_05_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataEntity05Service {

  constructor(private http: HttpClient) { }

  GetSingle(Token: String,
    id: Number,
    dataentity_id: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Dataentityno05/GetSingle?token=" + Token
      + "&id=" + id
      + "&dataentity_id=" + dataentity_id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  Submit(
    model_temp: DataEntity_Main_05_Interface,
    detail: Array<DataEntity_Detail_05_Interface>,
    resolution: Array<DataEntity_Resolution_05_Interface>,
    resolution_Thermometer: Array<DataEntity_Resolution_05_Interface>,
    resolution_Working: Array<DataEntity_Working_05_Interface>,
    DataEntity_id: number,
    Calibration_Id: number,
    Filename: string,
    Filename1: string,
    FolderName: string,

    Capability: string,
    DeviceSerial: string,
    DeviceCode: string,

    Manufacture_txt: String,
    Type_txt: String,
    Model_txt: String,
    LabAddress_txt: String,
    DELIVERY_TIME: Number,

    Fororaftegi_txt: String,
    working_temp_min_txt: String,
    working_temp_max_txt: String,

    Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var detail_list = []
    var mesured_list = []


    for (let item of detail) {
      detail_list.push({
        id: item.id,
        main_id: model_temp.id,

        indication: item.indication,
        reference: item.reference,
        correction: item.correction,
        uncertainty: item.uncertainty,
        converage: item.converage,

        before: item.before,
        status: item.status,
      })
    }

    var model={
      id:model_temp.id,
      filename: Filename,
      filename1: Filename1,
      pdf_src: FolderName,
      delivery_time: DELIVERY_TIME,
      manufacture: Manufacture_txt,
      type: Type_txt,
      model: Model_txt,

      capability: Capability,


      fororaftegi: Fororaftegi_txt,
      working_temp_min: working_temp_min_txt,
      working_temp_max: working_temp_max_txt,

      unit_setPoint: model_temp.unit_setPoint,
      unit_reference: model_temp.unit_reference,
      unit_indication: model_temp.unit_indication,

      unit_instability: model_temp.unit_instability,
      unit_inhomogeneity: model_temp.unit_inhomogeneity,
      unit_correction: model_temp.unit_correction,

      unit_correction_eqution: model_temp.unit_correction_eqution,
      unit_uncertainty: model_temp.unit_uncertainty,
      unit_working: model_temp.unit_working,

      temperature_Air_before: model_temp.temperature_Air_before +'',
      temperature_Air_after: model_temp.temperature_Air_after+'',

      humidity_Air_before: model_temp.humidity_Air_before+'',
      humidity_Air_after: model_temp.humidity_Air_after+'',

      pressure_before: model_temp.pressure_before+'',
      pressure_after: model_temp.pressure_after+'',

      working_type: Number(model_temp.working_type),

      type1: model_temp.type1,
      manufacture1: model_temp.manufacture1,
      model1: model_temp.model1,
      model2: model_temp.model2,
      code1: model_temp.code1,
      serial1: model_temp.serial1,

      range_nominal: model_temp.range_nominal,
      range_nominal_unit: model_temp.range_nominal_unit,
    }

    var body = {
      Calibration_id: Calibration_Id,
      model: model,
      resolution : resolution,
      thermostat : resolution_Thermometer,
      working : resolution_Working,
      detail: detail_list,
      mesured: mesured_list,
      DeviceSerial: DeviceSerial,
      DeviceCode: DeviceCode,
      Token: Token,
      labAdderss: LabAddress_txt,
      dataentity_id: DataEntity_id,
    }


    return this.http.post(environment.BaseUrl + "Daro/Dataentityno05/Submit", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  uploadFile(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno05/upload?token="+Token,body).pipe(
      map(data=>{
        return data
      })
    )
  }

  uploadPdf(body,Token:String){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno05/uploadPdf?token="+Token,body).pipe(
      map(data=>{
        return data
      })
    )
  }



}
